import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { carBrands, machineStatusOptions, renderMachineStatusOption } from "../_Utils/AppDocuCommon";
import ReactQuill from "react-quill";

/**
 * VehicleDialogForm - Form comune per AddVehicleDialog e EditVehicleDialog
 * Props:
 *   itemData: oggetto dati macchina
 *   onChange: funzione (nuovoItemData) => void
 *   disabled: boolean (opzionale)
 */
export default function VehicleDialogForm({ itemData, onChange, disabled }) {
  return (
    <Grid container spacing={3}>
      {/* Colonna sinistra: dati tecnici */}
      <Grid item xs={12} md={5}>
        <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>Info</Typography>
        <Grid container spacing={1}>
          {/* Brand, Model, Engine Code su una riga */}
          <Grid item xs={4}>
            <Autocomplete
              freeSolo
              fullWidth
              options={carBrands}
              value={itemData.brand || ''}
              onChange={(_, newValue) => onChange({ ...itemData, brand: newValue || '' })}
              renderInput={(params) => <TextField {...params} size="small" label="Brand" disabled={disabled} />}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField size="small" fullWidth label="Model" value={itemData.model || ''} onChange={e => onChange({ ...itemData, model: e.target.value })} disabled={disabled} />
          </Grid>
          <Grid item xs={4}>
            <TextField size="small" fullWidth label="Engine Code" value={itemData.engine_code || ''} onChange={e => onChange({ ...itemData, engine_code: e.target.value })} disabled={disabled} />
          </Grid>
        </Grid>
        <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>Technical</Typography>
        <Grid container spacing={1}>
          {/* Cylinders, Displacement, Power su una riga */}
          <Grid item xs={4}>
            <TextField
              size="small"
              fullWidth
              label="Cylinders"
              type="number"
              value={itemData.cylinders || '4'}
              onChange={e => { const val = e.target.value; if (/^\d*$/.test(val)) onChange({ ...itemData, cylinders: val }); }}
              InputProps={{ inputProps: { min: 0 }, disabled }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              size="small"
              fullWidth
              label="Displacement (cc)"
              type="number"
              value={itemData.displacement || '0'}
              onChange={e => { const val = e.target.value; if (/^\d*$/.test(val)) onChange({ ...itemData, displacement: val }); }}
              InputProps={{ endAdornment: <span style={{ marginLeft: 4 }}>cc</span>, inputProps: { min: 0 }, disabled }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              size="small"
              fullWidth
              label="Power (kW)"
              type="number"
              value={itemData.power || '0'}
              onChange={e => { const val = e.target.value; if (/^\d*$/.test(val)) onChange({ ...itemData, power: val }); }}
              InputProps={{ endAdornment: <span style={{ marginLeft: 4 }}>kW</span>, inputProps: { min: 0 }, disabled }}
            />
          </Grid>
          {/* Euro Code e Petrol ECU su una riga */}
          <Grid item xs={4}>
            <TextField size="small" fullWidth label="Euro Code" value={itemData.euro_code || ''} onChange={e => onChange({ ...itemData, euro_code: e.target.value })} disabled={disabled} />
          </Grid>
          <Grid item xs={8}>
            <TextField size="small" fullWidth label="Petrol ECU" value={itemData.petrol_ecu || ''} onChange={e => onChange({ ...itemData, petrol_ecu: e.target.value })} disabled={disabled} />
          </Grid>
        </Grid>
        <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>Evaluation</Typography>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <Autocomplete
              freeSolo
              options={machineStatusOptions.map(opt => opt.name)}
              value={itemData.status || ''}
              onInputChange={(_, newValue) => onChange({ ...itemData, status: newValue })}
              renderOption={renderMachineStatusOption}
              renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Status" disabled={disabled} />)}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* Colonna destra: note e status */}
      <Grid item xs={12} md={7}>
        <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>User Notes</Typography>
        <ReactQuill
          theme="snow"
          value={itemData.user_notes || ''}
          onChange={val => onChange({ ...itemData, user_notes: val })}
          style={{ background: '#fff', marginBottom: 10 }}
          className="mui-quill-rounded"
        />
        <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>Internal Notes</Typography>
        <ReactQuill
          theme="snow"
          value={itemData.internal_notes || ''}
          onChange={val => onChange({ ...itemData, internal_notes: val })}
          style={{ background: '#fff', marginBottom: 10 }}
          className="mui-quill-rounded"
        />        
      </Grid>
    </Grid>
  );
}
